import React, { createContext, useContext, useCallback } from "react";
import { api, quickTellerApi } from "../api";

const ApiContext = createContext();

export const ApiProvider = ({ children }) => {
  const apiCall = useCallback(
    async (
      endpoint,
      method = "GET",
      data = null,
      useQuickTellerApi = false,
      isFormData = false,
      headers = {}
    ) => {
      // debugger;
      if (!isFormData) {
        headers["Content-Type"] = "application/json";
      }
      const axiosInstance = useQuickTellerApi ? quickTellerApi : api;
      try {
        const response = await axiosInstance({
          url: endpoint,
          method,
          data,
          headers,
        });
        if (response.status === 200 || response.status === 201) {
          return response.data;
        }
      } catch (error) {
        // Check if this is actually a successful 201 response
        if (error.response && error.response.status === 201) {
          return error.response.data;
        }
        console.error(`API call to ${endpoint} failed:`, error);
        throw error;
      }
    },
    []
  );

  return (
    <ApiContext.Provider value={{ apiCall }}>{children}</ApiContext.Provider>
  );
};

export const useApi = () => {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error("useApi must be used within an ApiProvider");
  }
  return context;
};
